module.exports = __webpack_public_path__ + "media/images/front/icons/calendar-c4a48ac683d0dace675978f6b637df35.svg";